import { MainService } from '@beatgig/api-services'

export class DiscoverPage {
  static get() {
    return MainService.getDiscoverPage({})
  }
}
